// ADD PROBLEM
export const ADD_PROBLEM_REQUEST = 'ADD_PROBLEM_REQUEST';
export const ADD_PROBLEM_SUCCESS = 'ADD_PROBLEM_SUCCESS';
export const ADD_PROBLEM_FAIL = 'ADD_PROBLEM_FAIL';

// UPDATE PROBLEM
export const UPDATE_PROBLEM_REQUEST = 'UPDATE_PROBLEM_REQUEST';
export const UPDATE_PROBLEM_SUCCESS = 'UPDATE_PROBLEM_SUCCESS';
export const UPDATE_PROBLEM_FAIL = 'UPDATE_PROBLEM_FAIL';

// DELETE PROBLEM
export const DELETE_PROBLEM_REQUEST = 'DELETE_PROBLEM_REQUEST';
export const DELETE_PROBLEM_SUCCESS = 'DELETE_PROBLEM_SUCCESS';
export const DELETE_PROBLEM_FAIL = 'DELETE_PROBLEM_FAIL';

// CLEARING STATES
export const CLEAR_PROBLEM_STATS = 'CLEAR_PROBLEM_STATS';

// UPDATING TECH RECOMENDATION AND CONCERNS LIST
export const UPDATE_CONCERNS_RECOMENDATION_LIST =
  'UPDATE_CONCERNS_RECOMENDATION_LIST';
